import React from 'react';
import { Droplet, GraduationCap, Sparkles, HeartPulse, Beaker, Apple } from 'lucide-react';
import { benefitsGrid } from '../mock';

const iconMap = {
  Droplet: Droplet,
  GraduationCap: GraduationCap,
  Sparkles: Sparkles,
  HeartPulse: HeartPulse,
  Beaker: Beaker,
  Apple: Apple
};

const colorMap = {
  teal: { bg: 'rgba(0, 191, 255, 0.2)', icon: '#00BFFF' },
  blue: { bg: 'rgba(126, 192, 214, 0.2)', icon: '#7EC0D6' },
  green: { bg: 'rgba(92, 112, 128, 0.3)', icon: '#00BFFF' },
  amber: { bg: 'rgba(126, 192, 214, 0.2)', icon: '#7EC0D6' }
};

export const BenefitsGrid = () => {
  return (
    <section id="benefits" style={{
      background: '#434B54',
      padding: '8rem 1.5rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle Mountain Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.08
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', Georgia, serif",
            marginBottom: '1rem', 
            color: '#FFFFFF',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            fontStyle: 'italic'
          }}>Complete Program Package</h2>
          <p style={{ fontFamily: "'Open Sans', sans-serif", maxWidth: '700px', margin: '0 auto', color: '#E0E0E0', fontSize: '1.125rem' }}>
            Everything you need to implement cellular restoration at your facility
          </p>
        </div>

        {/* Benefits Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2rem'
        }}>
          {benefitsGrid.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            const colors = colorMap[benefit.color];
            return (
              <div
                key={benefit.id}
                className="feature-card hover-lift"
                style={{
                  background: 'rgba(58, 65, 73, 0.8)',
                  textAlign: 'center',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: colors.bg,
                  borderRadius: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem'
                }}>
                  <IconComponent size={40} color={colors.icon} />
                </div>
                <h3 style={{ fontFamily: "'Open Sans', sans-serif", marginBottom: '1rem', color: '#FFFFFF', fontWeight: 600, fontSize: '1.25rem' }}>
                  {benefit.title}
                </h3>
                <p style={{ fontFamily: "'Open Sans', sans-serif", lineHeight: '1.7', color: '#E0E0E0', fontSize: '0.95rem' }}>
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
